import { ArtifactsService } from '@inference.engine/api-client/web';
import { inferenceHttp } from '@/lib/api/http-client';
import type { FileAssetWithUrl } from '../model/chats.types';

/**
 * Saves a generated chat file (e.g. the translation agent's output spreadsheet)
 * as a context-less workspace artifact and returns the saved artifact's id. The
 * backend keys it by the asset id, so re-saving the same file is idempotent.
 */
export const saveFileArtifact = async (
  workspaceId: string,
  file: FileAssetWithUrl,
): Promise<string> => {
  const response = await ArtifactsService.saveFileArtifact({
    client: inferenceHttp,
    path: { workspaceId },
    body: {
      assetId: file.assetId,
      fileName: file.metadata.fileName,
      mimeType: file.mimeType,
      size: file.metadata.size,
    },
  });

  if (!response.data?.id) {
    throw new Error('Failed to save file artifact');
  }

  return response.data.id;
};
